import * as amplitude from "@amplitude/analytics-react-native";
import { PropsWithChildren, createContext, useEffect, useState } from "react";
import config from "../../config";
import { useCurrentUser } from "../../hooks";

export const AmplitudeContext = createContext(amplitude);

export const AmplitudeProvider = ({ children }: PropsWithChildren<{}>) => {
  const apiKey = config.amplitudeApiKey;

  const [isInitialized, setIsInitialized] = useState(false);
  const { currentUser } = useCurrentUser();
  useEffect(() => {
    if (!apiKey) {
      return;
    }

    if (!isInitialized) {
      amplitude.init(apiKey, currentUser?.memberNumber, {
        transport: "SendBeacon",
        flushIntervalMillis: 0,
        flushQueueSize: 1,
        trackingSessionEvents: true,
        defaultTracking: {
          pageViews: true,
          sessions: true,
          formInteractions: true,
        },
        attribution: {
          trackPageViews: true,
        },
      });
      setIsInitialized(true);
    }
    if (currentUser?.memberNumber) {
      amplitude.setUserId(currentUser?.memberNumber);
    }
  }, [isInitialized, apiKey]);

  return <AmplitudeContext.Provider value={amplitude}>{children}</AmplitudeContext.Provider>;
};
